// Computes whether a setup is currently in/near an attractive entry zone

const NEAR_ZONE_TOLERANCE_PCT = 2.0; // ±2% from zone edge counts as "near"

/**
 * Returns one of "in_zone" | "near_zone" | "far" | null (no data)
 */
export function computeProximity(setup) {
  const price = setup.last_price;
  if (price == null) return null;
  const entryType = setup.direction === "long" ? "long_entry" : "short_entry";
  const entries = (setup.zones || []).filter(z => z.type === entryType);
  if (entries.length === 0) return null;

  for (const z of entries) {
    const lo = Math.min(z.price_min, z.price_max);
    const hi = Math.max(z.price_min, z.price_max);
    if (price >= lo && price <= hi) return "in_zone";
  }
  // Check near
  for (const z of entries) {
    const lo = Math.min(z.price_min, z.price_max);
    const hi = Math.max(z.price_min, z.price_max);
    const tol = (NEAR_ZONE_TOLERANCE_PCT / 100) * ((lo + hi) / 2);
    if (price >= lo - tol && price <= hi + tol) return "near_zone";
  }
  return "far";
}

/**
 * "Attractive" = Friedrich ✅ marker OR price currently in/near zone
 */
export function isAttractive(setup) {
  if (setup.is_attractive_now) return true;
  const prox = computeProximity(setup);
  return prox === "in_zone" || prox === "near_zone";
}

export function proximityLabel(prox) {
  if (prox === "in_zone") return "IN ZONE";
  if (prox === "near_zone") return "NAH";
  return null;
}

export function proximityColor(prox) {
  if (prox === "in_zone") return "bg-emerald-500/20 text-emerald-400 border-emerald-500/40";
  if (prox === "near_zone") return "bg-amber-500/20 text-amber-400 border-amber-500/40";
  return "bg-zinc-800 text-zinc-500";
}
